import { compose } from 'recompose';

import ClientsList from './ClientsList';

const enhance = compose();

export default enhance(ClientsList);
